"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedPatchPaths = exports.userStatePath = exports.locationStatePath = void 0;
exports.locationStatePath = '/locationState';
exports.userStatePath = '/userState';
exports.allowedPatchPaths = [exports.locationStatePath, exports.userStatePath];
//# sourceMappingURL=notification.js.map